export default __webpack_public_path__ + "b6d20783395a07d5fbffb203705ac529.jpg";